import Component from "../abstracts/Component";

export default class TealiumLinkComponent extends Component {

  get SELECTORS() {
    return {
      main: ".js-cookie-preferences"
    };
  }

  constructor() {
    super()
  }

  bindEvents() {

    this.$on('click.tealium', ({event}) => {
      event.preventDefault();

      if (typeof tealiumMo2Div == 'undefined') {
        var old_v = $.fn.jquery;
        $.fn.jquery = '2.7.4';
        var tealiumMo2Div = document.createElement('SCRIPT');
        tealiumMo2Div.type = 'text/javascript';
        tealiumMo2Div.src = '//tags.tiqcdn.com/utag/' + utag.cfg.utid.split("/")[0] + '/' + utag.cfg.utid.split("/")[1] + '/' + utag.cfg.path.split('/')[6] + '/utag.tagsOptOut.js?cb=' + Math.random();
        document.getElementsByTagName('head')[0].appendChild(tealiumMo2Div);
        //utags load patch
        tealiumMo2Div.onload = function () {
          $.fn.jquery = old_v;
          delete __tealium.js1.onreadystatechange;
          var old_load = __tealium.js1.onload;
          __tealium.js1.onload = function () {
            old_load();
            setTimeout(function () {
              $("#__tealium_tagO2").closest(".ui-dialog.tealium").css('z-index', '99999');
            }, 150);
          };
        }

      } else {
        __tealium.init();
        $("#__tealium_tagO2").closest(".ui-dialog.tealium").css('z-index', '99999');
      };

    }, 'body', this.SELECTORS.main);


    this.$on(this.$customEvents.BACKDROP_EVENTS.hidden, () => {
      $('body .ui-dialog .ui-dialog-titlebar-close').trigger('mousedown.tealium');
    });

    jQuery(document.body).on('mousedown', '.ui-dialog .ui-dialog-titlebar-close', (e) => {
      this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
    });


  }

  render() {
    if (document.querySelector(this.SELECTORS.main)) this.bindEvents();
  }
}
